import { FocusNode } from '@please/lrud'
import styled from 'styled-components'

import { LineTileShape, LineTileSize } from '@sportworld/js-sdk/src/constants'

import arrowLeft from '@/assets/icons/arrow-left.svg'
import arrowRight from '@/assets/icons/arrow-right.svg'
import { focusedChannelTileScale } from '@/constants/tiles'

import { getTileProps } from './utils'

export const LineTitle = styled.div`
  font-size: 26px;
  line-height: 30px;
  font-weight: 700;
  text-transform: uppercase;
  padding-bottom: 12px;
`
export const SliderWrapper = styled.div`
  position: relative;
`
export const NavigationSection = styled.div<{
  $isVisible: boolean
}>`
  position: absolute;
  top: 0;
  height: 100%;
  width: 70px;
  opacity: ${({ $isVisible }) => ($isVisible ? '1' : '0')};
  transition: opacity 0.3s;
  z-index: 1;
  cursor: pointer;
  pointer-events: initial;

  &:after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: 34px;
    width: 34px;
    background-color: rgba(0, 0, 0, 0.7);
    background-repeat: no-repeat;
    background-position: center;
    background-size: 90% 90%;
    border-radius: 16px;
    z-index: 1;
    box-shadow: 0 0 1px rgba(255, 255, 255, 0.8);
  }
`
export const PrevNavigationSection = styled(NavigationSection)<{
  $isVisible: boolean
}>`
  left: -12px;
  width: 82px;
  &:after {
    background-image: url(\"${arrowLeft}\");
  }
`
export const NextNavigationSection = styled(NavigationSection)<{
  $isVisible: boolean
}>`
  right: 0%;
  pointer-events: none;
  &:after {
    background-image: url(\"${arrowRight}\");
  }
`
export const LineElem = styled(FocusNode)<{
  $isVisible: boolean
  $tileShape?: LineTileShape
  $tileSize?: LineTileSize
}>`
  opacity: ${({ $isVisible }) => ($isVisible ? '1' : '0')};
  transition: opacity 0.3s;
  pointer-events: none;

  & .swiper-wrapper {
    height: ${({ $tileShape, $tileSize }) =>
      `${getTileProps($tileShape, $tileSize).h}px`};
  }

  & .swiper-wrapper > * {
    pointer-events: initial;
  }
  & .slider__item,
  & .slider__item::after,
  &.isFocusedLeaf .swiper-slide-active .slider__item,
  &.isFocusedLeaf .swiper-slide-active .slider__item::after {
    will-change: transform;
    transition: transform 0.15s linear;
  }
  & .slider__item {
    & > img {
      filter: brightness(0.75);
    }
  }
  &.isFocusedLeaf .swiper-slide-active .slider__item {
    transform: ${({ $tileShape, $tileSize }) =>
      `scale(${getTileProps($tileShape, $tileSize).focusedTileScale})`};
    & > img {
      filter: brightness(1);
    }
  }

  & .slider__item::after {
    content: '';
    position: absolute;
    top: 0px;
    left: 0px;
    height: 100%;
    width: 100%;
    pointer-events: none;
    z-index: 10;
    box-shadow: inset 0px 0px 0px 4px transparent;
    border-radius: ${({ $tileShape, $tileSize }) =>
      $tileShape === LineTileShape.CIRCLE
        ? '50%'
        : $tileSize === LineTileSize.SMALL || $tileSize === LineTileSize.XSMALL
        ? '12px'
        : '24px'};
    overflow: hidden;
  }
  & .slider__item.empty__item::after {
    border-radius: 24px;
  }
  &.isFocusedLeaf .swiper-slide-active .slider__item::after,
  &.isFocusedLeaf .slider__item.empty__item::after {
    box-shadow: inset 0px 0px 0px 4px
      ${(props) => props.theme.colors.tiles.focusedElem.border};
  }
`

export const ChannelLineElem = styled(LineElem)`
  .swiper {
    width: 100%;
    margin: -12px 0 0 0 !important;
  }
  .slider__item {
    margin-bottom: 4px;
    box-shadow: 0px 0px 0px 4px transparent;
  }

  &.isFocusedLeaf .swiper-slide-active .slider__item {
    transform: scale(${focusedChannelTileScale});
    box-shadow: 0px 0px 0px 4px
      ${(props) => props.theme.colors.tiles.focusedElem.border};
  }
  &.isFocusedLeaf .swiper-slide-active .slider__item::after {
    display: none;
  }
`
